import { AppEdition, getCurrentAppEdition } from '@/shared/appEdition';

import { R } from '@/caregiverSpace/resources/Texts.resx';

export const formatNationalIdentifierText = (text: string): string => {
    const isNorway = getCurrentAppEdition() === AppEdition.Norway;

    return text
        .replaceAll('{NationalIdentifier}', isNorway ? R.Fodselsnummer : R.CPR)
        .replaceAll(
            '{NationalIdentifierExample}',
            isNorway ? '01012312345' : '010123-1234',
        );
};
